import React from "react";
import { XIcon } from "staysure-component-library";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import { RemoveSureModalContentTypes } from "@/types/review-types";

type OnchangeProps = {
  onChange?: (e: 0 | 1) => void;
};

function RemoveSureModalContent(
  props: Readonly<RemoveSureModalContentTypes & OnchangeProps>
) {
  const {
    ModalTitle,
    ModalContent,
    ModalButtonOne,
    ModalButtonTwo,
    setIsOpen,
    confirm,
    onChange,
  } = props;
  const [disabled, setDisabled] = React.useState(false);

  return (
    <div>
      <button
        id="remove-modal-content-close-button"
        type="button"
        className=" absolute right-4 top-4"
        onClick={() => {
          setIsOpen(false);
          if (onChange) onChange(0);
        }}
        aria-label="close modal"
      >
        <XIcon stroke="#306582 " />
      </button>
      <div
        className=" p-spacing-l md:p-spacing-xxxl flex-col "
        data-testid="removeSureModalContent-testid"
      >
        <div className="">
          <div className="mb-spacing-xs md:mb-spacing-s">
            <h1 className=" font-header-font w-[287px] md:w-[346px] lg:w-[348px] text-[23px] md:text-[31px] leading-custom-size-compact md:leading-[34.10px] text-text-title ">
              {ModalTitle || "Are you sure?"}
            </h1>
          </div>
          <div>
            <p className="text-text-body font-body-font font-normal text-xs leading-[27px] ">
              {ModalContent || "Confirm you want to remove Excess waiver."}
            </p>
          </div>
        </div>
        <div className=" mt-spacing-l flex flex-col md:flex-row justify-center gap-2">
          <LabelButtonWrapper
            data-testid="remove-sure-modal-content-confirm-button"
            id="remove-sure-modal-content-primary-button"
            isDisabled={disabled}
            label={ModalButtonOne}
            hierarchy="primary"
            type="button"
            onClick={() => {
              if (onChange) onChange(1);

              if (confirm) {
                setDisabled(true);
                confirm();
              }
              setIsOpen(false);
            }}
          />
          <LabelButtonWrapper
            data-testid="submitButton-testid"
            id="remove-sure-modal-content-secondary-button"
            isDisabled={disabled}
            label={ModalButtonTwo}
            hierarchy="secondary"
            type="button"
            onClick={() => {
              setIsOpen(false);
              if (onChange) onChange(0);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default RemoveSureModalContent;
